import { yupResolver } from '@hookform/resolvers/yup';
import { updatePasswordApi } from 'api/services/authentication';
import { Button } from 'components/Button';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useMediaQuery } from "react-responsive";
import { Bounce,toast } from "react-toastify";
import * as yup from 'yup';

const schema = yup.object().shape({
  newPassword: yup
    .string()
    .required('New password is required')
    .min(8, 'Password must be at least 8 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
    ),
  confirmPassword: yup
    .string()
    .required('Confirm password is required')
    .oneOf([yup.ref('newPassword')], 'Passwords must match')
});

const UpdatePassword = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [isResetSuccessful, setIsResetSuccessful] = useState(false);
  const [error, setError] = useState(null);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  const onSubmit = async (data) => {
    try {
    updatePasswordApi({password:data.newPassword}).then((res) => {
      console.log(res)
      setIsResetSuccessful(true);
      toast.success( "Password updated successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
      
    }).catch((err) => {
        toast.error(err.response?.data?.message || "Failed to update password. Please try again.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      console.log(err)
    })
    
    } catch (err) {
      setError("An unexpected error occurred. Please try again.");
    }
  };

  return (
    <div style={{ 
      padding: isMobile ? "0" : "0",
      background: "transparent",
      minHeight: "100%"
    }}>
      <div className="card shadow-sm" style={{ 
        maxWidth: isMobile ? '100%' : '600px', 
        width: '100%',
        margin: '0 auto',
        borderRadius: "8px",
        border: "none",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)"
      }}>
        <div className="card-header" style={{ 
          background: "transparent",
          borderBottom: "1px solid #e5e7eb",
          padding: isMobile ? "20px 16px" : "24px",
          borderRadius: "8px 8px 0 0"
        }}>
          <h3 className="mb-0" style={{ 
            fontSize: isMobile ? "20px" : "24px",
            fontWeight: "600",
            color: "#1f2937"
          }}>
            Update Password
          </h3>
          <p style={{ 
            fontSize: "14px",
            color: "#6b7280",
            marginTop: "8px",
            marginBottom: 0
          }}>
            Enter your new password below. Make sure it meets the security requirements.
          </p>
        </div>
        <div className="card-body" style={{ padding: isMobile ? "20px 16px" : "28px" }}>
          {isResetSuccessful ? (
            <div className="alert alert-success d-flex align-items-center" role="alert" style={{
              background: "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)",
              border: "1px solid #10b981",
              borderRadius: "8px",
              padding: "16px",
              color: "#065f46"
            }}>
              <i className="las la-check-circle me-2" style={{ fontSize: "20px" }}></i>
              <div>
                <strong>Success!</strong> Your password has been updated successfully.
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              {error && (
                <div className="alert alert-danger d-flex align-items-center" role="alert" style={{
                  background: "linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)",
                  border: "1px solid #ef4444",
                  borderRadius: "8px",
                  padding: "16px",
                  color: "#991b1b",
                  marginBottom: "20px"
                }}>
                  <i className="las la-exclamation-circle me-2" style={{ fontSize: "20px" }}></i>
                  <div>{error}</div>
                </div>
              )}
              
              <div className="mb-4" style={{ position: "relative" }}>
                <label htmlFor="newPassword" className="form-label" style={{ 
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#374151",
                  marginBottom: "8px"
                }}>
                  New Password
                </label>
                <div style={{ position: "relative" }}>
                <input
                    type={showNewPassword ? "text" : "password"}
                  className={`form-control ${errors.newPassword ? 'is-invalid' : ''}`}
                  id="newPassword"
                    placeholder="Enter your new password"
                    style={{
                      padding: "12px 45px 12px 16px",
                      borderRadius: "8px",
                      border: errors.newPassword ? "2px solid #ef4444" : "1px solid #d1d5db",
                      fontSize: "14px",
                      transition: "all 0.2s ease"
                    }}
                  {...register('newPassword')}
                    onFocus={(e) => {
                      e.target.style.borderColor = errors.newPassword ? "#ef4444" : "rgb(211, 0, 26)";
                      e.target.style.boxShadow = "0 0 0 3px rgba(211, 0, 26, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = errors.newPassword ? "#ef4444" : "#d1d5db";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      background: "transparent",
                      border: "none",
                      color: "#6b7280",
                      cursor: "pointer",
                      padding: "4px 8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <i className={showNewPassword ? "las la-eye-slash" : "las la-eye"} style={{ fontSize: "18px" }}></i>
                  </button>
                </div>
                {errors.newPassword && (
                  <div className="invalid-feedback d-block" style={{ 
                    color: "#ef4444",
                    fontSize: "13px",
                    marginTop: "6px"
                  }}>
                    <i className="las la-exclamation-circle me-1"></i>
                    {errors.newPassword.message}
                  </div>
                )}
              </div>
              
              <div className="mb-4" style={{ position: "relative" }}>
                <label htmlFor="confirmPassword" className="form-label" style={{ 
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#374151",
                  marginBottom: "8px"
                }}>
                  Confirm New Password
                </label>
                <div style={{ position: "relative" }}>
                <input
                    type={showConfirmPassword ? "text" : "password"}
                  className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                  id="confirmPassword"
                    placeholder="Confirm your new password"
                    style={{
                      padding: "12px 45px 12px 16px",
                      borderRadius: "8px",
                      border: errors.confirmPassword ? "2px solid #ef4444" : "1px solid #d1d5db",
                      fontSize: "14px",
                      transition: "all 0.2s ease"
                    }}
                  {...register('confirmPassword')}
                    onFocus={(e) => {
                      e.target.style.borderColor = errors.confirmPassword ? "#ef4444" : "rgb(211, 0, 26)";
                      e.target.style.boxShadow = "0 0 0 3px rgba(211, 0, 26, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = errors.confirmPassword ? "#ef4444" : "#d1d5db";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      background: "transparent",
                      border: "none",
                      color: "#6b7280",
                      cursor: "pointer",
                      padding: "4px 8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <i className={showConfirmPassword ? "las la-eye-slash" : "las la-eye"} style={{ fontSize: "18px" }}></i>
                  </button>
                </div>
                {errors.confirmPassword && (
                  <div className="invalid-feedback d-block" style={{ 
                    color: "#ef4444",
                    fontSize: "13px",
                    marginTop: "6px"
                  }}>
                    <i className="las la-exclamation-circle me-1"></i>
                    {errors.confirmPassword.message}
                  </div>
                )}
              </div>
              
              <div style={{ 
                background: "#f3f4f6",
                padding: "16px",
                borderRadius: "8px",
                marginBottom: "24px"
              }}>
                <div style={{ fontSize: "13px", fontWeight: "600", color: "#374151", marginBottom: "8px" }}>
                  Password Requirements:
                </div>
                <ul style={{ 
                  fontSize: "12px", 
                  color: "#6b7280", 
                  margin: 0, 
                  paddingLeft: "0",
                  listStyle: "none"
                }}>
                  <li style={{ marginBottom: "4px" }}>
                    <i className="las la-check" style={{ color: "#10b981", marginRight: "6px" }}></i>
                    At least 8 characters
                  </li>
                  <li style={{ marginBottom: "4px" }}>
                    <i className="las la-check" style={{ color: "#10b981", marginRight: "6px" }}></i>
                    One uppercase letter
                  </li>
                  <li style={{ marginBottom: "4px" }}>
                    <i className="las la-check" style={{ color: "#10b981", marginRight: "6px" }}></i>
                    One lowercase letter
                  </li>
                  <li style={{ marginBottom: "4px" }}>
                    <i className="las la-check" style={{ color: "#10b981", marginRight: "6px" }}></i>
                    One number
                  </li>
                  <li>
                    <i className="las la-check" style={{ color: "#10b981", marginRight: "6px" }}></i>
                    One special character (!@#$%^&*)
                  </li>
                </ul>
              </div>
              
              <Button
                type="submit"
                label="Update Password"
                className="btn w-100"
                style={{
                  background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                  border: "none",
                  borderRadius: "8px",
                  padding: "14px 24px",
                  fontSize: "15px",
                  fontWeight: "600",
                  color: "#ffffff",
                  boxShadow: "0 4px 12px rgba(211, 0, 26, 0.3)",
                  transition: "all 0.2s ease"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 6px 16px rgba(211, 0, 26, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(211, 0, 26, 0.3)";
                }}
              />
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdatePassword;
